export default function Ornament() {
  return (
    <div
      className="flex items-center justify-center gap-3 pt-4"
      aria-hidden="true"
    >
      <span className="h-px w-16 bg-gradient-to-r from-transparent to-[#D4AF37]/70"></span>
      <span className="w-2 h-2 rotate-45 border border-[#D4AF37]/80"></span>
      <span className="w-1.5 h-1.5 rotate-45 bg-[#D4AF37]"></span>
      <span className="w-2 h-2 rotate-45 border border-[#D4AF37]/80"></span>
      <span className="h-px w-16 bg-gradient-to-l from-transparent to-[#D4AF37]/70"></span>
    </div>
  );
}
